import React from 'react';
import {Dimensions} from 'react-native';
import {Card, Image} from '@rneui/themed';

import {AirtableAttachmentDetail} from '../../models/airtable';
import SeeAllButton from '../rewards/SeeAllButton';
import Text from '../themed/Text';
import PressableWithOpacityFeedback from '../ui-controls/PressableWithOpacityFeedback';

type TileLargeProps = {
  image: AirtableAttachmentDetail;
  title: string;
  description: string;
  onPress: () => void;
};

/**
 * Large Tile used for exclusive offers and promotions carousel
 */
const TileLarge = ({image, title, description, onPress}: TileLargeProps) => {
  return (
    <PressableWithOpacityFeedback onPress={onPress}>
      <Card
        noMargin
        radius="rounded-lg"
        variant="outlined"
        containerStyle={{
          flex: 1,
          maxWidth: 370,
          width: Dimensions.get('window').width - 60,
        }}
        wrapperStyle={{
          gap: 12,
        }}>
        <Image
          source={{uri: image?.url}}
          containerStyle={{
            aspectRatio: 1.54,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            borderRadius: 5,
          }}
        />
        <Text noMargin variant="heading1">
          {title}
        </Text>
        <Text numberOfLines={2}>{description}</Text>
        <SeeAllButton variant="small" text="Learn more" spaceBetween onPress={onPress} />
      </Card>
    </PressableWithOpacityFeedback>
  );
};

export default TileLarge;
